import React from 'react';
import { motion } from 'framer-motion';

const Overview = () => {
    const containerVariants = {
        hidden: { opacity: 0 },
        visible: {
            opacity: 1,
            transition: { staggerChildren: 0.15 }
        }
    };

    const itemVariants = {
        hidden: { opacity: 0, y: 30 },
        visible: {
            opacity: 1,
            y: 0,
            transition: { duration: 0.6, ease: "easeOut" }
        }
    };

    return (
        <section className="w-full bg-[#F1F1F1] py-16 lg:py-24 overflow-hidden select-none text-left relative z-50">
            <div className="max-w-[1440px] w-full mx-auto px-[20px] lg:px-[80px]">

                <motion.div
                    variants={containerVariants}
                    initial="hidden"
                    whileInView="visible"
                    viewport={{ once: true, amount: 0.2 }}
                    className="flex flex-col lg:grid lg:grid-cols-12 gap-0 items-center w-full relative min-h-auto lg:min-h-[480px]"
                >

                    <motion.div
                        variants={itemVariants}
                        className="w-full sm:max-w-[625px] lg:max-w-none lg:col-span-6 bg-[#030c22] overflow-hidden rounded-none shadow-[0_10px_30px_rgba(0,0,0,0.02)] relative z-10 aspect-[4/3] sm:aspect-[16/10] lg:aspect-auto"
                    >
                        <img
                            src="/assets/diversity/img5.png"
                            alt="3D Abstract geometric violet and silver twisting shape artwork"
                            className="w-full h-full object-cover transition-transform duration-700 ease-out hover:scale-104"
                        />
                    </motion.div>

                    <motion.div
                        variants={itemVariants}
                        className="w-full max-w-full lg:absolute lg:right-0 bg-white border border-b-0 border-[#01386A45] p-6 sm:p-12 lg:p-14 flex flex-col items-start rounded-none group shadow-[0_15px_40px_rgba(0,0,0,0.06)] lg:max-w-[785px] z-20 mt-[-20px] sm:mt-[-40px] lg:mt-0 relative"
                    >
                        <div className="absolute bottom-0 left-0 right-0 h-[4px] bg-[#01386A] z-10" />
                        <div className="absolute bottom-0 left-0 w-0 h-[4px] bg-[#EA580C] z-20 transition-all duration-500 ease-out group-hover:w-full" />

                        <div className="w-full flex flex-col items-start max-w-[530px] relative z-30">
                            <h2 className="text-[#01386A] text-[20px] lg:text-[30px] font-[600] tracking-tight leading-tight mb-4 sm:mb-5 font-sora">
                                Overview
                            </h2>
                            <p className="text-[#49577A] text-[14px] sm:text-[16px] leading-relaxed font-[500] font-graphik">
                                Cybage has embraced diversity, inclusivity, and equity since its inception. We respect the unique needs, viewpoints, and capabilities of all our employees, and our commitment to becoming a workplace where everyone feels equally involved in and supported has only gotten stronger over the years.
                            </p>
                        </div>
                    </motion.div>

                </motion.div>

            </div>
        </section>
    );
};

export default Overview;